// pages/Unauthorized.jsx
import React from 'react';

function Unauthorized() {
  return (
    <>
      <h2>Unauthorized Access</h2>
      <p>You do not have permission to view this page.</p>
    </>
  );
}

export default Unauthorized;
